// @owners { team: patients-team }
import { Button } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React, { useCallback } from 'react';
import { openCart } from '~shared/actions/ui/cart';
import { useCartEssentials } from '~shared/features/essentials';
import { getIsEditingExistingOrder } from '~shared/features/ui/selectors/getCart';
import { useDispatchShared, useSelectorShared } from '~shared/store';

type EditCartButtonProps = {
  readonly disabled?: boolean;
};

export const EditCartButton = ({ disabled = false }: EditCartButtonProps = {}) => {
  const { navigate } = useNavigation();
  const dispatch = useDispatchShared();
  const hideEditCart = useSelectorShared(getIsEditingExistingOrder);
  const { hasEssentials, hasNonEssentials } = useCartEssentials();
  const shouldOpenStore = hasEssentials && !hasNonEssentials;

  const handleEditCart = useCallback(() => {
    if (shouldOpenStore) {
      navigate('RouteEssentials');
      return;
    }
    navigate('RouteAppTabNavigator', { screen: 'RouteTabMyMeds' });
    dispatch(openCart());
  }, [dispatch, navigate, shouldOpenStore]);

  if (hideEditCart) return null;
  return (
    <Button
      type="secondary"
      onPress={handleEditCart}
      disabled={disabled}
    >
      Edit cart
    </Button>
  );
};
